import React from 'react';
import { PDFDownloadLink } from '@react-pdf/renderer';
import PdfDocument from '../pdfDocument';

export const DownloadPdfButton = ({formData, isInternal, attachments}) => {
  
  return (
    <div className="download-row">
      <PDFDownloadLink
        document={
          <PdfDocument 
            data={formData} 
            files={attachments.map(attachment => attachment?.fileName)} 
            isInternal={isInternal}/>
        }
        fileName="RFI.pdf"
        style={{
          textDecoration: "none",
          color: 'white',
          textAlign: 'center'
        }}
        className="download-button"
        >
        {({ blob, url, loading, error }) =>
          loading ? "Loading document..." : "Download PDF"
        }
      </PDFDownloadLink>
    </div>
  )
}